import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { Alert, Autocomplete } from '@material-ui/lab'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, makeStyles, Paper, Snackbar, TextField } from '@material-ui/core'
import RemoveIcon from '@material-ui/icons/Delete'

import { getHasRequestError, getHasRequestPending } from '../../../redux/data/selectors'
import { ADD_CONTENT_GROUP_USER } from '../../../redux/data/types'

const useStyles = makeStyles(() => ({
  assignedSection: {
    marginTop: '1rem',
  },
  assignedUser: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '5px'
  },
  userText: {
    margin: 'auto 0.5rem',
  },
  removeButton: {
    padding: '4px',
    borderRadius: '4px',
    margin: '5px 3px 5px 0px',
  },
}))

const AddUsersDialog = props => {
  const { isOpen, users, groupUsers, onAdd, onRemove, onClose, requestPending, requestError, groupID } = props
  const [selected, setSelected] = useState([])
  const [showSnackbar, setShowSnackbar] = useState(false)
  const classes = useStyles()

  let snackMessage = requestPending ? 'Assigning Users' : 'Users Assigned'
  if (requestError) {
    snackMessage = 'Error: ' + requestError
  }

  const handleCloseSnackbar = () => setShowSnackbar(false)

  useEffect(() => {
    if (requestPending || requestError) {
      setShowSnackbar(true)
    }
  }, [requestPending, requestError])

  const unassignedUsers = users.filter(user => !groupUsers.some(groupUser => user.userId === groupUser.userId))
  const assignedUsers = users.filter(user => !unassignedUsers.find(unassigned => unassigned.userId === user.userId))

  const handleRemove = user => {
    onRemove(user, groupID)
  }

  return (
    <>
      <Snackbar
        open={showSnackbar}
        autoHideDuration={9000}
        onClose={handleCloseSnackbar}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={
            requestError ? 'error' : requestPending ? 'info' : 'success'
          }
        >
          {snackMessage}
        </Alert>
      </Snackbar>
      <Dialog open={isOpen} onClose={onClose}>
        <DialogTitle>Select users to assign to this group</DialogTitle>
        <DialogContent>
          <div>
            <Autocomplete
              onChange={(ev, val) => setSelected(val)}
              disableCloseOnSelect
              autoComplete
              autoHighlight
              multiple
              filterOptions={(options, state) => {
                //filter out all of the users assigned to this content group
                return options.filter((user) =>
                  state
                    .getOptionLabel(user)
                    .toLowerCase()
                    .includes(state.inputValue.toLowerCase())
                )
              }}
              options={unassignedUsers}
              getOptionLabel={(user) => user.firstName + ' ' + user.lastName}
              filterSelectedOptions
              value={selected.filter(
                (selectedUser) =>
                  !groupUsers.some(
                    (groupUser) => groupUser.userId === selectedUser.userId
                  )
              )}
              renderInput={(params) => {
                return (
                  <TextField
                    {...params}
                    variant='outlined'
                    placeholder='Users'
                  />
                )
              }}
            />
            {assignedUsers.length ? (
              <div className={classes.assignedSection}>
                Assigned:
                {assignedUsers.map((user) => (
                  <Paper className={classes.assignedUser}>
                    <span className={classes.userText}>
                      {user.firstName} {user.lastName}
                    </span>
                    <IconButton
                      color='secondary'
                      className={classes.removeButton}
                      onClick={() => {
                        handleRemove(user)
                      }}
                    >
                      <RemoveIcon />
                    </IconButton>
                  </Paper>
                ))}
              </div>
            ) : null}
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color='secondary' variant='contained'>
            Close
          </Button>
          <Button
            onClick={() => onAdd(selected)}
            color='primary'
            variant='contained'
            disabled={selected.length === 0}
          >
            Assign
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

const mapStateToProps = (state) => {
  const requestPending = getHasRequestPending(state, ADD_CONTENT_GROUP_USER)
  const requestError = getHasRequestError(state, ADD_CONTENT_GROUP_USER)
  return { requestPending, requestError }
}

export default connect(mapStateToProps)(AddUsersDialog)
